import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { api } from "@/api/client";
// import MDEditor, { commands } from '@uiw/react-md-editor';
// import '@uiw/react-md-editor/markdown-editor.css';
// import '@uiw/react-markdown-preview/markdown.css';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { UploadDialog, UploadDialogRef } from "./components/UploadDialog";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PaginationComponent } from "@/components/Pagination";
import { ConfirmDialog } from "@/components/ConfirmDialog";
import Header from "@/components/header";
import { toast } from "sonner";
import { CustomTypeFilterComponent } from "./components/CustomSelectFilter";
import { CustomStatusFilterComponent } from "./components/CustomStatusFilter";
import { CustomCheckStateFilterComponent } from "./components/CustomCheckStateFilter";
import { useTranslation } from "@/locales";

// ag-grid-communityUI开始导入
import type {
  ColDef,
  RowSelectionOptions,
  ICellRendererParams,
  ValueFormatterParams,
  LocaleTextFunc,
  ClientSideRowModelModule,
  ColGroupDef,
  DataTypeDefinition,
  GridApi,
  GridOptions,
  GridReadyEvent,
  ModuleRegistry,
  TextFilterModule,
  ValidationModule,
} from "ag-grid-community";
// Core CSS
import { AG_GRID_LOCALE_HK } from "@ag-grid-community/locale";
import { AgGridReact } from "ag-grid-react";
import { themeQuartz } from "ag-grid-community"; // 从 ag-grid-community 导入
import { colorSchemeDarkWarm } from "ag-grid-community";

// 深色主题风格
// const themeDarkWarm = themeQuartz.withPart(colorSchemeDarkWarm);
const themeDarkWarm = themeQuartz.withPart(colorSchemeDarkWarm).withParams({
  backgroundColor: "#1d1d1d",
});
import pdfImage from "@/assets/search/pdf.png";
import mdImage from "@/assets/search/ic-MarkDown.svg";
import { useTheme } from "@/contexts/ThemeContext";
import { envStorage } from "@/utils/envCache";

// 定义表格数据类型
interface fileData {
  name: string;
  fileId: React.Key | null | undefined;
  id: number;
  fileName: string;
  state: "WAITING" | "PROCESSING" | "ERROR" | "SUCCESS";
  knowledgeName: string;
  creator: string;
  createTime: string;
  checkState: "PENDING" | "CHECKED";
  checker: string;
  checkerEmail: string;
  checkTime: string;
  type: "PDF" | "TEXT" | "HTML";
  fileSize: string;
}

const markdownContent =
  '3 永越多元货幣保險計劃II加碼回贈\n\n同一保單主權人及受保人成功投保永明港卓越醫療保、永明港無憂醫療保、永明港稱心醫療保或永明港健康醫療保 + 該保單亦於2025年11月30日或之前簽發\n\n永越多元貨幣保險計劃II長期客戶回贈  \n（只適用於12年繳及18年繳保單）\n\n為了答謝您的支持，您可於保單繳付年期完結時享有高達首年度年度化保費18%的長期客戶回贈之保費回贈。\n\n<table>\n  <tr>\n    <th colspan="6">首年年度化保費</th>\n    <th>基本回贈</th>\n    <th>加碼回贈</th>\n    <th>長期客戶回贈</th>\n  </tr>\n  <tr>\n    <th>美元</th>\n    <th>加元</th>\n    <th>英鎊</th>\n    <th>人民幣</th>\n    <th>澳元</th>\n    <th>港元</th>\n    <th>回贈</th>\n    <th>回贈</th>\n    <th>回贈</th>\n  </tr>\n  <tr>\n    <th colspan="9">永越多元貨幣保險計劃II (6年繳)</th>\n  </tr>\n  <tr>\n    <td>200,000或以上</td>\n    <td>240,000或以上</td>\n    <td>140,000或以上</td>\n    <td>1,400,000或以上</td>\n    <td>300,000或以上</td>\n    <td>1,600,000或以上</td>\n    <td>22%</td>\n    <td rowspan="8">額外3%</td>\n    <td rowspan="8">不適用</td>\n  </tr>\n  <tr>\n    <td>100,000 - 199,999</td>\n    <td>120,000 - 239,999</td>\n    <td>70,000 - 139,999</td>\n    <td>700,000 - 1,399,999</td>\n    <td>150,000 - 299,999</td>\n    <td>800,000 - 1,599,999</td>\n    <td>20%</td>\n  </tr>\n  <tr>\n    <td>50,000 - 99,999</td>\n    <td>60,000 - 119,999</td>\n    <td>35,000 - 69,999</td>\n    <td>350,000 - 699,999</td>\n    <td>75,000 - 149,999</td>\n    <td>400,000 - 799,999</td>\n    <td>18%</td>\n  </tr>\n  <tr>\n    <td>30,000 - 49,999</td>\n    <td>36,000 - 59,999</td>\n    <td>21,000 - 34,999</td>\n    <td>210,000 - 349,999</td>\n    <td>45,000 - 74,999</td>\n    <td>240,000 - 399,999</td>\n    <td>16%</td>\n  </tr>\n  <tr>\n    <td>10,000 - 29,999</td>\n    <td>12,000 - 35,999</td>\n    <td>7,000 - 20,999</td>\n    <td>70,000 - 209,999</td>\n    <td>15,000 - 44,999</td>\n    <td>80,000 - 239,999</td>\n    <td>10%</td>\n  </tr>\n  <tr>\n    <td>5,000 - 9,999</td>\n    <td>6,000 - 11,999</td>\n    <td>3,500 - 6,999</td>\n    <td>35,000 - 69,999</td>\n    <td>7,500 - 14,999</td>\n    <td>40,000 - 79,999</td>\n    <td>7%</td>\n  </tr>\n  <tr>\n    <td>2,000 - 4,999</td>\n    <td>2,400 - 5,999</td>\n    <td>1,400 - 3,499</td>\n    <td>14,000 - 34,999</td>\n    <td>3,000 - 7,499</td>\n    <td>16,000 - 39,999</td>\n    <td>5%</td>\n  </tr>\n  <tr>\n    <td>2,000以下</td>\n    <td>2,400以下</td>\n    <td>1,400以下</td>\n    <td>14,000以下</td>\n    <td>3,000以下</td>\n    <td>16,000以下</td>\n    <td>-</td>\n  </tr>\n  <tr>\n    <th colspan="9">永越多元貨幣保險計劃II (12年繳)</th>\n  </tr>\n  <tr>\n    <td>200,000或以上</td>\n    <td>240,000或以上</td>\n    <td>140,000或以上</td>\n    <td>1,400,000或以上</td>\n    <td>300,000或以上</td>\n    <td>1,600,000或以上</td>\n    <td>22%</td>\n    <td rowspan="11">額外3%</td>\n    <td rowspan="11">12%</td>\n  </tr>\n  <tr>\n    <td>100,000或以上</td>\n    <td>120,000或以上</td>\n    <td>70,000或以上</td>\n    <td>700,000或以上</td>\n    <td>150,000或以上</td>\n    <td>800,000或以上</td>\n    <td>20%</td>\n  </tr>\n  <tr>\n    <td>100,000 - 199,999</td>\n    <td>120,000 - 239,999</td>\n    <td>70,000 - 139,999</td>\n    <td>700,000 - 1,399,999</td>\n    <td>150,000 - 299,999</td>\n    <td>800,000 - 1,599,999</td>\n    <td>20%</td>\n  </tr>\n  <tr>\n    <td>50,000 - 99,999</td>\n    <td>60,000 - 119,999</td>\n    <td>35,000 - 69,999</td>\n    <td>350,000 - 699,999</td>\n    <td>75,000 - 149,999</td>\n    <td>400,000 - 799,999</td>\n    <td>18%</td>\n  </tr>\n  <tr>\n    <td>30,000 - 49,999</td>\n    <td>36,000 - 59,999</td>\n    <td>21,000 - 34,999</td>\n    <td>210,000 - 349,999</td>\n    <td>45,000 - 74,999</td>\n    <td>240,000 - 399,999</td>\n    <td>17%</td>\n  </tr>\n  <tr>\n    <td>10,000 - 29,999</td>\n    <td>12,000 - 35,999</td>\n    <td>7,000 - 20,999</td>\n    <td>70,000 - 209,999</td>\n    <td>15,000 - 44,999</td>\n    <td>80,000 - 239,999</td>\n    <td>16%</td>\n  </tr>\n  <tr>\n    <td>5,000 - 9,999</td>\n    <td>6,000 - 11,999</td>\n    <td>3,500 - 6,999</td>\n    <td>35,000 - 69,999</td>\n    <td>7,500 - 14,999</td>\n    <td>40,000 - 79,999</td>\n    <td>14%</td>\n  </tr>\n  <tr>\n    <td>3,000 - 4,999</td>\n    <td>3,600 - 5,999</td>\n    <td>2,100 - 3,499</td>\n    <td>21,000 - 34,999</td>\n    <td>4,500 - 7,499</td>\n    <td>24,000 - 39,999</td>\n    <td>13%</td>\n  </tr>\n  <tr>\n    <td>1,500 - 2,999</td>\n    <td>1,800 - 3,599</td>\n    <td>1,050 - 2,099</td>\n    <td>10,500 - 20,999</td>\n    <td>2,250 - 4,499</td>\n    <td>12,000 - 23,999</td>\n    <td>12%</td>\n  </tr>\n  <tr>\n    <td>1,500以下</td>\n    <td>1,800以下</td>\n    <td>1,050以下</td>\n    <td>10,500以下</td>\n    <td>2,250以下</td>\n    <td>12,000以下</td>\n    <td>-</td>\n  </tr>\n  <tr>\n    <th colspan="9">永越多元貨幣保險計劃II (18年繳)</th>\n  </tr>\n  <tr>\n    <td>100,000或以上</td>\n    <td>120,000或以上</td>\n    <td>70,000或以上</td>\n    <td>700,000或以上</td>\n    <td>150,000或以上</td>\n    <td>800,000或以上</td>\n    <td>20%</td>\n    <td rowspan="9">額外3%</td>\n    <td rowspan="9">18%</td>\n  </tr>\n  <tr>\n    <td>50,000 - 99,999</td>\n    <td>60,000 - 119,999</td>\n    <td>35,000 - 69,999</td>\n    <td>350,000 - 699,999</td>\n    <td>75,000 - 149,999</td>\n    <td>400,000 - 799,999</td>\n    <td>18%</td>\n  </tr>\n  <tr>\n    <td>30,000 - 49,999</td>\n    <td>36,000 - 59,999</td>\n    <td>21,000 - 34,999</td>\n    <td>210,000 - 349,999</td>\n    <td>45,000 - 74,999</td>\n    <td>240,000 - 399,999</td>\n    <td>17%</td>\n  </tr>\n  <tr>\n    <td>10,000 - 29,999</td>\n    <td>12,000 - 35,999</td>\n    <td>7,000 - 20,999</td>\n    <td>70,000 - 209,999</td>\n    <td>15,000 - 44,999</td>\n    <td>80,000 - 239,999</td>\n    <td>16%</td>\n  </tr>\n  <tr>\n    <td>5,000 - 9,999</td>\n    <td>6,000 - 11,999</td>\n    <td>3,500 - 6,999</td>\n    <td>35,000 - 69,999</td>\n    <td>7,500 - 14,999</td>\n    <td>40,000 - 79,999</td>\n    <td>14%</td>\n  </tr>\n  <tr>\n    <td>3,000 - 4,999</td>\n    <td>3,600 - 5,999</td>\n    <td>2,100 - 3,499</td>\n    <td>21,000 - 34,999</td>\n    <td>4,500 - 7,499</td>\n    <td>24,000 - 39,999</td>\n    <td>13%</td>\n  </tr>\n  <tr>\n    <td>1,500 - 2,999</td>\n    <td>1,800 - 3,599</td>\n    <td>1,050 - 2,099</td>\n    <td>10,500 - 20,999</td>\n    <td>2,250 - 4,499</td>\n';
export default function fileData() {
  const { t } = useTranslation();
  const [markdownValue, setMarkdownValue] = useState<string>(markdownContent);
  const navigate = useNavigate();

  const [DialogData, setDialogData] = useState({
    title: "",
    description: "",
    confirmText: "",
  });

  // 在组件挂载后设置翻译
  useEffect(() => {
    setDialogData({
      title: t("admin.confirmDeleteTitle"),
      description: t("admin.confirmDeleteDescription"),
      confirmText: t("common.confirm"),
    });
  }, []);

  // 状态管理
  // 判断当前主题是否是深色模式
  // const [isDarkMode, setIsDarkMode] = useState(false);
  const { resolvedTheme } = useTheme();
  const isDarkMode = resolvedTheme === "dark";
  //批量选中
  const [selectedRows, setSelectedRows] = useState<fileData[]>([]);
  const uploadDialogRef = useRef<UploadDialogRef>(null);
  const [data, setData] = useState<fileData[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // 排序单独存储
  const [sortParams, setSortParams] = useState<{
    sort: string;
    direction: string;
  } | null>(null);

  // 用于上传人和核对人筛选
  const [creatorFilter, setCreatorFilter] = useState<string>("");
  const [checkerFilter, setCheckerFilter] = useState<string>("");
  const [teamUsers, setTeamUsers] = useState<any[]>([]);
  const [isTeamUsersLoading, setIsTeamUsersLoading] = useState<boolean>(true);

  // 添加知识库相关状态
  const [knowledgeFilter, setKnowledgeFilter] = useState<string>("");
  const [knowledgeList, setKnowledgeList] = useState<KnowledgeItem[]>([]);
  const [isKnowledgeLoading, setIsKnowledgeLoading] = useState<boolean>(true);

  // 获取团队用户列表
  const fetchTeamUsers = async () => {
    try {
      setIsTeamUsersLoading(true);
      const response: any = await api.get("/v1/admin/team/user");
      setTeamUsers(response.content || response);
    } catch (err) {
      console.error("获取团队用户列表失败:", err);
    } finally {
      setIsTeamUsersLoading(false);
    }
  };

  // 获取知识库列表
  const fetchKnowledgeList = async () => {
    try {
      setIsKnowledgeLoading(true);
      const response: any = await api.get("/v1/admin/knowledge/list");
      setKnowledgeList(response || []);
    } catch (err) {
      console.error("获取知识库列表失败:", err);
    } finally {
      setIsKnowledgeLoading(false);
    }
  };

  useEffect(() => {
    fetchTeamUsers();
    fetchKnowledgeList();
  }, []);
  // 手动搜索
  const handleManualSearch = () => {
    // 重置到第一页并重新获取数据
    setQueryParams((prev) => ({
      ...prev,
      page: 0,
    }));
    // getList();
  };

  // 重置搜索条件
  const handleReset = () => {
    setSearchTerm("");
    setCreatorFilter("");
    setCheckerFilter("");
    setKnowledgeFilter(""); // 重置知识库筛选

    // 重置到第一页并重新获取数据
    setQueryParams((prev) => ({
      ...prev,
      page: 0,
    }));
    // setTimeout(() => {
    //     getList("");
    // }, 0);
  };
  //刷新
  const handleRefresh = () => {
    getList();
  };

  // 创建弹窗的引用
  const deleteDialogRef = useRef<any>(null);

  // 分页参数
  const [queryParams, setQueryParams] = useState<any>({
    page: 0,
    size: 30,
  });
  const [total, setTotal] = useState(0); // 总条数

  // 获取列表数据
  const getList = async (name?: any, passedSortParams?: { sort: string; direction: string }) => {
    try {
      setData([]);
      setLoading(true);

      // 如果没有传入排序参数，但有保存的排序参数，则使用保存的
      const finalSortParams = passedSortParams || sortParams;

      // 构建请求参数，包含所有当前的筛选条件
      const requestParams: any = {
        ...queryParams,
        fileName: name ? name : searchTerm || "",
        creatorUid: creatorFilter || "",
        checkerUid: checkerFilter || "",
        knowledgeId: knowledgeFilter || "", // 添加知识库筛选参数
        ...finalSortParams, // 添加排序参数
      };

      // 调用 GET 请求
      const response: any = await api.get("/v1/admin/knowledge/files", {
        params: requestParams,
      });

      console.log(response);
      setData(response.content); // 存储接口返回的数据
      setTotal(response.page.totalElements);
    } catch (err) {
      console.error("获取文件列表失败:", err);
      setError(t("admin.loadFileListFailed"));
    } finally {
      setLoading(false); // 无论成功失败，都结束加载状态
    }
  };

  const upList = async (page: number, limit: number) => {
    // 更新参数
    setQueryParams({
      ...queryParams,
      page: page,
      size: limit,
    });

    console.log(`获取第${page}页数据，每页${limit}条`);
  };
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (sortParams) {
        getList(searchTerm, sortParams);
      } else {
        getList(searchTerm);
      }
    }, 500);

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [queryParams.page, queryParams.size, queryParams, creatorFilter, checkerFilter, knowledgeFilter]);

  // 在 useEffect 中统一处理过滤器事件
  useEffect(() => {
    // 统一处理所有过滤器变化
    const handleFilterChange = (event: CustomEvent) => {
      const { field, value } = event.detail;
      console.log(`Filter changed - ${field}:`, value);

      // 更新对应的查询参数，保留其他字段
      setQueryParams((prev) => {
        const newParams = { ...prev };

        if (value === undefined || value === null || value === "") {
          delete newParams[field];
        } else {
          (newParams as any)[field] = value;
        }

        return {
          ...newParams,
          page: 0,
        };
      });
    };

    // 添加事件监听器
    window.addEventListener("filterChanged", handleFilterChange as EventListener);

    return () => {
      // 清理事件监听器
      window.removeEventListener("filterChanged", handleFilterChange as EventListener);
    };
  }, [sortParams]);

  // 排序处理函数
  const onSortChanged = (event: any) => {
    const columnState = event.api.getColumnState();
    const sortedColumn = columnState.find((col: any) => col.sort);

    if (sortedColumn) {
      // 当有列被排序时，移除提示图标样式
      const style = document.getElementById("grid-sort-icons");
      if (style) {
        style.innerHTML = `.ag-header-cell[col-id="createTime"] .ag-header-cell-label::after,
                .ag-header-cell[col-id="checkTime"] .ag-header-cell-label::after {
                    display: none !important;
                }
            `;
      }

      let newSortParam = {};

      // 根据不同的列设置不同的sort参数
      if (sortedColumn.colId === "createTime") {
        newSortParam = {
          sort: "id",
          direction: sortedColumn.sort === "asc" ? "ASC" : "DESC",
        };
      } else if (sortedColumn.colId === "checkTime") {
        newSortParam = {
          sort: "checkTime",
          direction: sortedColumn.sort === "asc" ? "ASC" : "DESC",
        };
      } else {
        // 其他列使用默认处理
        setSortParams(null);
        getList(searchTerm);
        return;
      }

      // 保存排序参数
      setSortParams(newSortParam as { sort: string; direction: string });
      // 调用带排序参数的接口
      getList(searchTerm, newSortParam);
    } else {
      // 当没有列被排序时，恢复提示图标样式
      const style = document.getElementById("grid-sort-icons");
      if (style) {
        style.innerHTML = `.ag-header-cell[col-id="createTime"] .ag-header-cell-label::after,
                .ag-header-cell[col-id="checkTime"] .ag-header-cell-label::after {
                    content: " ⇅";
                    font-size: 14px;
                    opacity: 0.7;
                    margin-left: 5px;
                }
            `;
      }

      // 清除排序参数
      setSortParams(null);
      // 恢复默认排序
      getList(searchTerm);
    }
  };

  // 删除 文件
  const [currentFileToDelete, setCurrentFileToDelete] = useState<fileData | null>(null);

  const handleDeleteFile = async (file: fileData) => {
    try {
      const response: any = await api.post("/v1/admin/knowledge/file/delete", null, {
        params: {
          fileId: file.fileId,
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      if (response) {
        toast.success(t("admin.fileDeleteSuccess"));
        getList(); // 刷新列表
      } else {
        toast.error(t("admin.fileDeleteFailed"));
      }
    } catch (error) {
      console.error("删除文件时出错:", error);
      toast.error(t("admin.deleteFileError"));
    }
  };

  // 批量删除
  const handleBatchDelete = async () => {
    if (selectedRows.length === 0) {
      toast.warning(t("admin.pleaseSelectAtLeastOneFile"));
      return;
    }
    try {
      // 循环调用单个删除接口
      const deletePromises = selectedRows.map((file) =>
        api.post("/v1/admin/knowledge/file/delete", null, {
          params: {
            fileId: file.fileId,
          },
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
      );
      // 等待所有删除操作完成
      const results = await Promise.all(deletePromises);
      // 检查是否有删除成功的响应
      const successCount = results.filter((result) => result).length;
      if (successCount > 0) {
        toast.success(t("admin.deleteFilesSuccess", { count: successCount }));
        setSelectedRows([]);
        setQueryParams((prev) => ({
          ...prev,
          page: 0,
        })); // 刷新列表
      } else {
        toast.error(t("admin.batchDeleteFailed"));
      }
    } catch (error) {
      console.error("批量删除文件时出错:", error);
      toast.error(t("admin.batchDeleteError"));
    }
  };

  const confirmDelete = (file: fileData) => {
    setCurrentFileToDelete(file);
    setDialogData({
      title: t("common.confirmDelete"),
      description: t("common.confirmDeleteFile", { fileName: file.name }),
      confirmText: t("common.ok"),
    });

    deleteDialogRef.current?.open();
  };

  const onRetry = async (item: any) => {
    try {
      setIsSubmitting(true);
      const res: any = await api.post(
        "/v1/admin/knowledge/file/retry",
        {},
        {
          params: {
            fileId: item.fileId,
          },
        }
      );
      if (res.type) {
        // 接口成功
        setIsSubmitting(false);
        setQueryParams((prev) => ({
          ...prev,
          page: 0,
        }));
      } else {
        // 接口返回错误信息
        console.log(res.message || "新增邀请用户失败，请重试");
      }
    } catch (error) {
      // 捕获网络等异常错误
      console.log("网络异常，请稍后重试");
      setIsSubmitting(false);
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleFileClick = (data: any) => {
    console.log(data);
    const query: any = {
      fileId: data.fileId,
      type: data.type,
    };
    const currentUrl = window.location.href;
    const currentPathIndex = currentUrl.indexOf("#");
    const baseUrl = currentPathIndex !== -1 ? currentUrl.substring(0, currentPathIndex) : currentUrl.replace(/\/?$/, "/");
    // 将 data 对象序列化为 JSON 字符串并进行 URL 编码
    const dataParam = encodeURIComponent(JSON.stringify(query));
    const url = `${baseUrl}#/admin/fileDataEditor?data=${dataParam}`;

    console.log(url);
    window.open(url, "_blank");
  };

  const location = useLocation();
  // 当前路由的路径  现在暂时用路径判断，到最终用权限判断显示用户前端界面  还是管理后端的界面
  const currentPath = location.pathname;
  const admin = envStorage.getItem("admin") === "true";
  useEffect(() => {
    //监听标识变化，如果是用户，不给去管理后端
    if (!admin) {
      if (currentPath.indexOf("/admin") !== -1) {
        navigate("/", { replace: true });
      }
    }
    //非完全控制菜单的权限，跳转回首页
    if (envStorage.getItem("isFULL_CONTROL") !== "FULL_CONTROL") {
      navigate("/", { replace: true });
    }
  }, [admin]);

  const localeText = AG_GRID_LOCALE_HK;
  // 列表配置
  const [columnDefs, setColDefs] = useState<ColDef[]>([]);

  // Initialize column definitions after translations are loaded
  useEffect(() => {
    const cols: ColDef[] = [
      {
        headerName: "",
        field: "checkbox",
        pinned: "left",
        maxWidth: 50,
        sortable: false,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        cellStyle: { textAlign: "center" },
        resizable: false, // 禁止调整列宽
        suppressMovable: true, // 禁止拖动列
        lockPosition: true, // 锁定列位置
      },
      //floatingFilter: true  高级过滤
      {
        headerName: t("admin.fileName"),
        field: "name",
        width: 400,
        flex: 0,
        maxWidth: 800,
        minWidth: 300,
        tooltipField: "name",
        cellRenderer: (params: ICellRendererParams) => {
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              {/* 固定宽度的图标容器 */}
              <div
                style={{
                  width: "24px",
                  minWidth: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "8px",
                }}
              >
                {params.data.type === "PDF" && <img src={pdfImage} style={{ width: "20px", height: "auto" }} alt="PDF" />}
                {params.data.type === "MD" && <img src={mdImage} style={{ width: "20px", height: "auto" }} alt="MD" />}
              </div>

              {/* 可省略的文本内容 */}
              <div
                onClick={() => handleFileClick(params.data)}
                style={{
                  flex: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                <span
                  style={{
                    color: "#0066cc",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  {params.value}
                </span>
              </div>
            </div>
          );
        },
        filterValueGetter: (params) => {
          return params.data.name;
        },
      },
      {
        headerName: t("admin.size"),
        field: "fileSize",
        minWidth: 100,
        maxWidth: 100,
        flex: 0,

        // suppressSizeToFit: true
      },
      {
        headerName: t("admin.type"),
        field: "type",
        minWidth: 80,
        maxWidth: 100,
        flex: 0,
        filter: "customTypeFilter", // 使用自定义过滤器
      },
      {
        headerName: t("admin.knowledgeBase"),
        field: "knowledgeName",
        minWidth: 120,
        maxWidth: 160,
        tooltipField: "knowledgeName",
      },
      {
        headerName: t("admin.status"),
        field: "state",
        maxWidth: 120,
        minWidth: 110,
        filter: "customStatusFilter", // 使用自定义过滤器
        cellRenderer: (params: ICellRendererParams) => {
          const style = params.value === "SUCCESS" ? { color: "#00b83d" } : params.value === "ERROR" ? { color: "#c5221f" } : { color: "#d9730d" };

          return (
            <div
              style={{
                ...style,
                padding: "2px 8px",
                borderRadius: "4px",
              }}
            >
              {/*{params.value}*/}
              {params.value === "SUCCESS" && <span>{t("admin.success")}</span>}
              {params.value === "ERROR" && (
                <div>
                  <span>{t("admin.failed")}</span>
                  <Button style={{ height: "25px", marginLeft: "0.3rem" }} disabled={isSubmitting} size="sm" onClick={() => onRetry(params.data)}>
                    {t("admin.retry")}
                  </Button>
                </div>
              )}
              {params.value === "PROCESSING" && <span>{t("admin.parsing")}</span>}
              {params.value === "WAITING" && <span>{t("admin.pendingParse")}</span>}
            </div>
          );
        },
        filterValueGetter: (params) => {
          // 根据原始值返回对应的中文显示文本，用于筛选
          switch (params.data.state) {
            case "SUCCESS":
              return t("admin.success");
            case "ERROR":
              return t("admin.failed");
            case "PROCESSING":
              return t("admin.parsing");
            case "WAITING":
              return t("admin.pendingParse");
            default:
              return params.data.state;
          }
        },
      },
      {
        headerName: t("admin.uploader"),
        field: "creatorEmail",
        maxWidth: 165,
        minWidth: 140,
        cellRenderer: (params: ICellRendererParams) => {
          //当使用自定义 cellRenderer 时，tooltipField 可能不会按预期工作。这是因为自定义渲染器覆盖了默认的单元格行为。
          const creator = params.data.creator || "";
          const creatorEmail = params.data.creatorEmail || "";

          // 合并两个值作为工具提示内容
          const tooltipText = creator && creatorEmail ? `${creator}\n${creatorEmail}` : creator || creatorEmail || "";
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              title={tooltipText}
            >
              <div style={{ height: "15px" }}>{creator}</div>
              <div
                style={{
                  color: "gray",
                  fontSize: "0.9em",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {creatorEmail}
              </div>
            </div>
          );
        },
      },
      {
        headerName: t("admin.uploadTime"),
        field: "createTime",
        maxWidth: 160,
        flex: 0,
        tooltipField: "createTime",
        sortable: true,
      },
      {
        headerName: t("admin.checkStatus"),
        field: "checkState",
        filter: "customCheckStateFilter",
        maxWidth: 110,
        minWidth: 108,
        cellRenderer: (params: ICellRendererParams) => {
          const style = params.value === "CHECKED" ? { color: "#00b83d" } : params.value === "PENDING" ? { color: "#d9730d" } : { color: "#d9730d" };

          return (
            <div
              style={{
                ...style,
                padding: "2px 8px",
                borderRadius: "4px",
              }}
            >
              {params.value === "CHECKED" && <span>{t("admin.checked")}</span>}
              {params.value === "PENDING" && <span>{t("admin.pendingCheck")}</span>}
            </div>
          );
        },
        filterValueGetter: (params) => {
          // 根据原始值返回对应的中文显示文本，用于筛选
          switch (params.data.checkState) {
            case "CHECKED":
              return t("admin.checked");
            case "PENDING":
              return t("admin.pendingCheck");
            default:
              return params.data.checkState;
          }
        },
      },
      {
        headerName: t("admin.checker"),
        field: "checker",
        maxWidth: 200,
        minWidth: 140,
        cellRenderer: (params: ICellRendererParams) => {
          //当使用自定义 cellRenderer 时，tooltipField 可能不会按预期工作。这是因为自定义渲染器覆盖了默认的单元格行为。
          const checker = params.data.checker || "--";
          const checkerEmail = params.data.checkerEmail || "--";

          // 合并两个值作为工具提示内容
          const tooltipText = checker && checkerEmail ? `${checker}\n${checkerEmail}` : checker || checkerEmail || "";
          return (
            <div style={{ display: "flex", flexDirection: "column" }} title={tooltipText}>
              <div style={{ height: "15px" }}>{checker}</div>
              <div
                style={{
                  color: "gray",
                  fontSize: "0.9em",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {checkerEmail}
              </div>
            </div>
          );
        },
      },
      {
        headerName: t("admin.checkTime"),
        field: "checkTime",
        maxWidth: 160,
        minWidth: 145,
        tooltipField: "checkTime",
        sortable: true,
      },
      {
        headerName: t("admin.operation"),
        width: 80,
        resizable: false, // 禁止调整列宽
        sortable: false,
        pinned: "right",
        suppressMovable: true, // 禁止拖动列
        cellRenderer: (params: ICellRendererParams) => {
          return (
            <div className="text-red-600" style={{ cursor: "pointer", marginLeft: "10px" }} onClick={() => confirmDelete(params.data)}>
              {t("admin.delete")}
            </div>
            /*<DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <div style={{color:'#003dc5'}}>· · ·</div>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent>
                            <DropdownMenuItem onClick={() => console.log('编辑', params.data)}>
                                核对
                            </DropdownMenuItem>
                            <DropdownMenuItem onClick={() => console.log('详情', params.data)}>
                                重命名
                            </DropdownMenuItem>
                            <DropdownMenuSeparator />
                            <DropdownMenuItem
                                className="text-red-600"
                                onClick={() => confirmDelete(params.data)}
                            >
                                删除
                            </DropdownMenuItem>
                        </DropdownMenuContent>
                    </DropdownMenu>*/
          );
        },
        cellStyle: {
          textAlign: "center",
          padding: "5px",
        },
      },
    ];

    setColDefs(cols);
  }, [t, isSubmitting]); // Add dependencies

  const defaultColDef: ColDef = {
    flex: 1,
    // filter: true,
    sortable: false, //是否有排序
    // 允许单元格内容被选中
    cellStyle: {
      display: "flex",
      alignItems: "center",
      userSelect: "text", // 核心配置：允许文本被选中
      WebkitUserSelect: "text", // 兼容webkit内核浏览器
      MozUserSelect: "text", // 兼容Firefox
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    cellRenderer: (params: ICellRendererParams) => {
      return (
        <div
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {params.value}
        </div>
      );
    },
  };

  return (
    <div className="flex flex-col pl-4 pr-4 py-12 pt-0 dark:bg-[#1d1d1d] bg-[#ffffff]" style={{ width: "100%", overflow: "auto" }}>
      <style id="grid-sort-icons">
        {`.ag-header-cell[col-id="createTime"] .ag-header-cell-label::after,
            .ag-header-cell[col-id="checkTime"] .ag-header-cell-label::after {
                content: " ⇅";
                font-size: 14px;
                opacity: 0.7;
                margin-left: 5px;
            }`}
      </style>
      <Header title={t("admin.fileCollection")} />
      {/*<MDEditor*/}
      {/*    value={markdownValue}*/}
      {/*    onChange={setMarkdownValue}*/}
      {/*    height={'100%'}*/}
      {/*    preview="edit"*/}
      {/*    textareaProps={{*/}
      {/*        style: {*/}
      {/*            caretColor: 'currentColor',*/}
      {/*            WebkitTextFillColor: 'currentColor',*/}
      {/*            WebkitAppearance: 'none',*/}
      {/*            position: 'relative',*/}
      {/*            zIndex: 2,*/}
      {/*            backgroundColor: 'transparent',*/}
      {/*            userSelect: 'text',*/}
      {/*            WebkitUserSelect: 'text',*/}
      {/*        },*/}
      {/*        spellCheck: false,*/}
      {/*    }}*/}
      {/*/>*/}
      <div className="space-y-4 flex-shrink-0">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mx-auto space-y-4 mt-5">
          <div className="flex flex-wrap items-center gap-4 mb-0">
            <div className="flex items-center">
              <span className="whitespace-nowrap" style={{ fontSize: "15px" }}>
                {t("admin.name")}:
              </span>
              <Input
                style={{
                  display: "inline-block",
                  marginLeft: "10px",
                  height: "32px",
                }}
                placeholder={`${t("admin.name")}${t("common.search")}...`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleManualSearch()}
                className="w-52 ml-2"
              />
            </div>

            <div className="flex items-center">
              <span className="whitespace-nowrap" style={{ fontSize: "15px" }}>
                {t("admin.knowledgeBase")}:
              </span>
              <Select value={knowledgeFilter} onValueChange={setKnowledgeFilter} disabled={isKnowledgeLoading}>
                <SelectTrigger className="w-40 ml-2">
                  <SelectValue placeholder={t("admin.pleaseSelectKnowledgeBase")} />
                </SelectTrigger>
                <SelectContent>
                  {knowledgeList.map((knowledge) => (
                    <SelectItem key={knowledge.knowledgeId} value={knowledge.knowledgeId.toString()}>
                      {knowledge.knowledgeName}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="flex items-center">
              <span className="whitespace-nowrap" style={{ fontSize: "15px" }}>
                {t("admin.uploader")}:
              </span>
              <Select value={creatorFilter} onValueChange={setCreatorFilter} disabled={isTeamUsersLoading}>
                <SelectTrigger className="w-40 ml-2">
                  <SelectValue placeholder={t("admin.pleaseSelectUploader")} />
                </SelectTrigger>
                <SelectContent>
                  {teamUsers.map((user) => (
                    <SelectItem key={user.email || user.id} value={user.uid || `user-${user.uid}`}>
                      {user.nickname}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="flex items-center">
              <span className="whitespace-nowrap" style={{ fontSize: "15px" }}>
                {t("admin.checker")}:
              </span>
              <Select value={checkerFilter} onValueChange={setCheckerFilter} disabled={isTeamUsersLoading}>
                <SelectTrigger className="w-40 ml-2">
                  <SelectValue placeholder={t("admin.pleaseSelectChecker")} />
                </SelectTrigger>
                <SelectContent>
                  {teamUsers.map((user) => (
                    <SelectItem key={user.id} value={user.uid || `user-${user.uid}`}>
                      {user.nickname}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="flex items-center gap-2">
              <Button onClick={handleManualSearch}>{t("admin.search")}</Button>
              <Button variant="outline" size="sm" onClick={handleReset} className="h-8 px-3">
                {t("admin.reset")}
              </Button>
              <Button variant="outline" size="sm" onClick={handleRefresh} className="h-8 px-3">
                {t("admin.refresh")}
              </Button>
              {selectedRows.length > 0 && (
                <Button
                  variant="destructive"
                  size="sm"
                  onClick={() => {
                    // toast.info('功能正在开发中...')
                    // return
                    setDialogData({
                      title: t("admin.confirmBatchDelete"),
                      description: `${t("admin.confirmBatchDeleteMessage")}`,
                      confirmText: t("admin.confirmDeleteButton"),
                    });
                    deleteDialogRef.current?.open();
                  }}
                  className="h-8 px-3"
                >
                  {t("admin.deleteSelectedFiles")}
                </Button>
              )}
            </div>
          </div>

          <div className="mt-2 md:mt-0">
            <Button
              variant="default"
              size="sm"
              onClick={() => {
                uploadDialogRef.current?.open();
              }}
              className="h-8 px-3"
            >
              {t("admin.uploadFile")}
            </Button>
          </div>
        </div>

        <div className="flex-grow ag-theme-alpine" style={{ height: "calc(100vh - 205px)", width: "100%" }}>
          <AgGridReact
            theme={isDarkMode ? themeDarkWarm : themeQuartz} //themeQuartz 默认主题风格
            columnDefs={columnDefs}
            rowData={data}
            defaultColDef={defaultColDef}
            rowHeight={50}
            localeText={localeText}
            components={{
              customTypeFilter: CustomTypeFilterComponent,
              customStatusFilter: CustomStatusFilterComponent,
              customCheckStateFilter: CustomCheckStateFilterComponent,
            }}
            onSortChanged={onSortChanged} // 添加排序变化监听
            rowSelection="multiple"
            onSelectionChanged={(event) => {
              const selectedNodes = event.api.getSelectedNodes();
              const selectedData = selectedNodes.map((node) => node.data);
              setSelectedRows(selectedData);
            }}
            suppressRowClickSelection={true}
            // 加载状态相关属性
            loadingOverlayComponent={() => (
              <div className="ag-custom-loading">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    flexDirection: "column",
                  }}
                >
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mb-2"></div>
                  <span>{t("common.loading")}</span>
                </div>
              </div>
            )}
            loadingOverlayComponentParams={{
              loadingMessage: t("common.loading"),
            }}
            noRowsOverlayComponent={() => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  padding: "20px",
                }}
              >
                <div>{t("common.noData")}</div>
              </div>
            )}
            // 控制何时显示加载状态
            loading={loading}
          />
        </div>
      </div>
      {/* 分页组件 */}
      {total > 0 && (
        <div className="flex-shrink-0 dark:bg-[#1d1d1d] bg-[#ffffff]">
          <PaginationComponent total={total} page={queryParams.page} limit={queryParams.size} pageSizes={[30, 40, 50]} onPagination={upList} prevNextType="icon" />
        </div>
      )}
      {/* 确认弹窗 */}
      <ConfirmDialog
        ref={deleteDialogRef}
        title={DialogData.title}
        description={DialogData.description}
        confirmText={DialogData.confirmText}
        onConfirm={() => {
          if (currentFileToDelete) {
            handleDeleteFile(currentFileToDelete);
            setCurrentFileToDelete(null);
          } else if (selectedRows.length > 0) {
            handleBatchDelete();
          }
        }}
      />

      <UploadDialog ref={uploadDialogRef} />
    </div>
  );
}

// 添加知识库接口定义
interface KnowledgeItem {
  knowledgeId: number;
  knowledgeName: string;
  createDate: string;
}
